vendas.component('vendas.vendasComponent', {
    templateUrl: 'vendas/vendas.html',
    controller: 'vendas.vendasController'
});

vendas.controller('vendas.vendasController', ['$scope', 'coreLanguage', '$state', 'coreFb', function($scope, $text, $state, $fb) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.$onInit = () => {
        $state.params.showGlobalLoading = false;
    }

    
}]);